import { render } from "./KioskLogin.vue?vue&type=template&id=97ba61a8&scoped=true"
import script from "./KioskLogin.vue?vue&type=script&lang=js"
export * from "./KioskLogin.vue?vue&type=script&lang=js"

import "./KioskLogin.vue?vue&type=style&index=0&id=97ba61a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ba61a8"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn});qInstall(script, 'directives', {ClosePopup});
